import { DateTime } from '@/shared/helpers'

export const assignmentIsDisable = (date: Date): boolean =>
  DateTime.createFromDate(new Date(date), false).greaterThanOrEqual(
    DateTime.today(),
  )
